// extracted by mini-css-extract-plugin
export default {"PaneHeaderIconButton":"PaneHeaderIconButton---D0qX6","PaneHeaderIconButton__inner":"PaneHeaderIconButton__inner---zHIjh boxOffsetSmall---_Mm5w"};